import { initializeApp } from "@firebase/app";
import { getMessaging, getToken } from "@firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyD8Mf8jHSTzXf2Tcwi6NRxm3q4d82jHykM",
  authDomain: "wings-3deb4.firebaseapp.com",
  projectId: "wings-3deb4",
  storageBucket: "wings-3deb4.firebasestorage.app",
  messagingSenderId: "20035559299",
  appId: "1:20035559299:web:d7c71c108c191a28c1e0b6",
  measurementId: "G-PPCZFWB57K"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
const messagingToken = getToken(messaging, { vapidKey: "BNwWUqCO26dbfmT_mMX41b73eRGEWuTT88iVJFfyB3PrKLGQaiZ-eNHqfVesndvbZZIKa1ncV0uscpgluRuQxJA" });

export { messaging, messagingToken };